/** @file Pins the id a create minted into its input, so the server keeps the client's id (E8-R4). */
import { lookupCommand } from '@pose2d/commands/lookupCommand';
import type { CommandCall, Id } from '@pose2d/format/types';

/** `call` with `input.id = created[input.name]` when the input has no id and the command's schema accepts one. */
export function pinCreatedId(call: CommandCall, created: Record<string, Id> | undefined): CommandCall {
  const { input } = call;
  if (typeof input !== 'object' || input === null || 'id' in input) return call;
  const name = (input as { name?: unknown }).name;
  const id = typeof name === 'string' ? created?.[name] : undefined;
  if (id === undefined) return call;
  const pinned = { ...input, id };
  return lookupCommand(call.name)?.input.safeParse(pinned).success === true ? { name: call.name, input: pinned } : call;
}
